"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDetailWrapper$ = exports.CompanyDetailWrapper$outboundSchema = exports.CompanyDetailWrapper$inboundSchema = void 0;
exports.companyDetailWrapperToJSON = companyDetailWrapperToJSON;
exports.companyDetailWrapperFromJSON = companyDetailWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const companydetailattributes_js_1 = require("./companydetailattributes.js");
const companydetailtype_js_1 = require("./companydetailtype.js");
/** @internal */
exports.CompanyDetailWrapper$inboundSchema = z.object({
    attributes: companydetailattributes_js_1.CompanyDetailAttributes$inboundSchema,
    id: z.string(),
    type: companydetailtype_js_1.CompanyDetailType$inboundSchema,
});
/** @internal */
exports.CompanyDetailWrapper$outboundSchema = z.object({
    attributes: companydetailattributes_js_1.CompanyDetailAttributes$outboundSchema,
    id: z.string(),
    type: companydetailtype_js_1.CompanyDetailType$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompanyDetailWrapper$;
(function (CompanyDetailWrapper$) {
    /** @deprecated use `CompanyDetailWrapper$inboundSchema` instead. */
    CompanyDetailWrapper$.inboundSchema = exports.CompanyDetailWrapper$inboundSchema;
    /** @deprecated use `CompanyDetailWrapper$outboundSchema` instead. */
    CompanyDetailWrapper$.outboundSchema = exports.CompanyDetailWrapper$outboundSchema;
})(CompanyDetailWrapper$ || (exports.CompanyDetailWrapper$ = CompanyDetailWrapper$ = {}));
function companyDetailWrapperToJSON(companyDetailWrapper) {
    return JSON.stringify(exports.CompanyDetailWrapper$outboundSchema.parse(companyDetailWrapper));
}
function companyDetailWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompanyDetailWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompanyDetailWrapper' from JSON`);
}
//# sourceMappingURL=companydetailwrapper.js.map